import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import addTrailingSlash from '../../../../utils/url/addTrailingSlash';
import { domainByLocale } from '../../../../config';

const createBaseDomain = (domain, locale) => addTrailingSlash(domain) + locale;

const AlternatePages = ({ alternatePages, domain }) => (
  <Head>
    { Object.entries(alternatePages).map(([locale, path]) => {
      const href = addTrailingSlash(`${domainByLocale(locale) || createBaseDomain(domain, locale)}${path}`);

      return (
        <link
          key={`${locale}-${path}`}
          rel="alternate"
          href={href}
          hrefLang={locale}
        />
      );
    })}
  </Head>
);

AlternatePages.propTypes = {
  alternatePages: PropTypes.objectOf(PropTypes.string).isRequired,
  domain: PropTypes.string.isRequired,
};

export default AlternatePages;

